import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-modal-img',
  templateUrl: './modal-img.component.html',
  styleUrls: ['./modal-img.component.scss']
})
export class ModalImgComponent {
  @Input() images: { itemImageSrc: string; thumbnailImageSrc: string }[];

  public displayBasic: boolean = false;
  public imagesData = [];
  public responsiveOptions = [];

  openPhoto() {
    for (let image of this.images) {
      this.imagesData.push({itemImageSrc: image, thumbnailImageSrc: image, alt: 'Description for Image 1', title: 'Title 1'});
    }

    this.responsiveOptions = [
      {
        breakpoint: '1500px',
        numVisible: 5
      },
      {
        breakpoint: '1024px',
        numVisible: 5
      },
      {
        breakpoint: '768px',
        numVisible: 5
      },
      {
        breakpoint: '560px',
        numVisible: 5
      }
    ];
    this.displayBasic = true;
  }
}
